module.exports = __webpack_public_path__ + "img/12.70369d21.jpg";